export enum OnboardingModalWindowType {
    Onboarding = "onboarding",
    Info = "info",
}
